import {TextField} from "@mui/material";
import React from "react";
import {FORM_VALUE_UPDATED, useFormDispatch, useFormState} from "./formContext";
import {useFieldValidation} from "./useFieldValidation";
import {useIsFieldRequired} from "./useIsFieldRequired";

export const TextFieldForm = ({formKey, label, ariaLabel, fullWidth=false, multiline=false, onBlur=null, ...rest}) => {
    const {
        formData,
        errors,
        isSubmitting,
    } = useFormState();
    const [touched, setTouched] = React.useState(false);

    const dispatch = useFormDispatch();
    useFieldValidation(formKey);
    const required = useIsFieldRequired(formKey);

    const changeHandler = event => {
        dispatch({
            type: FORM_VALUE_UPDATED,
            key: formKey,
            value: event.target.value
        });
    };

    const blurHandler = event => {
        setTouched(true);
        if (onBlur) {
            onBlur(event);
        }
    };

    const hasError = (touched || isSubmitting) && Boolean(errors[formKey]);

    return (
        <TextField
            id={formKey}
            name={label}
            label={label}
            helperText={hasError ? errors[formKey] : ariaLabel}
            error={hasError}
            value={formData[formKey] ?? ""}
            onChange={changeHandler}
            onBlur={blurHandler}
            required={required}
            multiline={multiline}
            fullWidth={fullWidth}
            {...rest}
        />
    );
};